import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { Controller, useFormContext } from "react-hook-form";
import { Fragment, ReactNode } from "react";
import FormField from "components/cck/FormField";
import NumberInput from "components/cck/NumberInput";
import { intl } from "LocaleWrapper";
import { AgreementFormByTypeProps } from "view/agreements/schema/schema";

type FormValues = {
	agreements: {
		days?: number;
	}[];
}

type FormField = {
	id: string;
	render: () => ReactNode;
}

const BlockFreightAgreementForm = ({ index, hiddenFields }: AgreementFormByTypeProps) => {
	const { control, formState: { errors } } = useFormContext<FormValues>();

	const BlockFreightAgreementFormFields: FormField[] = [
		{
			id: "agreement.days",
			render: () => (
				<Grid size={{ md: 4, xs: 12 }}>
					<FormField errors={errors} name={`agreements.${index}.days`}>
						<FormGroup label={intl.formatMessage({ id: "BLOCK_FREIGHT_DAYS" })} overflow="hidden" required>
							<Controller
								name={`agreements.${index}.days`}
								control={control}
								rules={{ required: true }}
								render={({ field }) => (
									<NumberInput
										{...field}
										addonAfter={intl.formatMessage({ id: "DAYS" })}
									/>
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
	];

	return (
		<>
			{BlockFreightAgreementFormFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default BlockFreightAgreementForm;
